// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__29Nnl","text":"Loader_text__1zUA3","loaderAlertWrapper":"Loader_loaderAlertWrapper__dO4YL"};